// TODO: detect if menu items are slotted and add class to ul

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-nav-item',
  styleUrl: 'navigation.css',
  shadow: false,
})
export class NavItem {
  @Prop() href: string = '#';
  @Prop() text: string = 'Link';
  @Prop() active: boolean = false;
  @Prop() hasSubNav: boolean = false;

  render() {
    return (
      <div class={this.active ? 'active nav-item-div' : 'nav-item-div'}>
        <a href={this.href}>
          {this.text}
          {this.hasSubNav ? <span class="arrow" aria-haspopup="true"></span> : ''}
        </a>
        <slot />
      </div>
    );
  }
}
